
import {Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'GoogleMapMarker',
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    marker: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      default: 'home',
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      allMarkers: [],
      mar: null,
    };
  },

  mounted() {
    const { Marker } = this.google.maps;
    this.mar = new Marker({
      position: this.marker,
      marker: this.marker,
      map: this.map,
      icon: `${require(`./${this.icon}-icon.svg`)}`,
    });

  },
})
export default class GoogleMapMarker extends Vue {
  public render() {}
}
